import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandler } from '../common/error-handler';

export interface InpostCategory {
  id: string;
  name: string;
  leaf: boolean;
  children?: InpostCategory[];
}

@Injectable()
export class InpostCategoryService {
  constructor(private readonly http: HttpClient) {}

  getCategories(categoryId?: string, depth?: number): Observable<InpostCategory[]> {
    const params: any = {};
    if (categoryId) params.categoryId = categoryId;
    if (depth !== undefined) params.depth = depth;
    return this.http
      .get<InpostCategory[]>('/api/inpost/categories', { params })
      .pipe(catchError(ErrorHandler.handleError('inpost-categories', [])));
  }

  refreshCategories(): Observable<{ leafCategories: number }> {
    return this.http
      .get<{ leafCategories: number }>('/api/inpost/categories/refresh')
      .pipe(catchError(ErrorHandler.handleError('inpost-categories-refresh', { leafCategories: 0 })));
  }

  resetCategoryCache(): Observable<{ resetCount: number }> {
    return this.http
      .get<{ resetCount: number }>('/api/inpost/categories/reset-cache')
      .pipe(catchError(ErrorHandler.handleError('inpost-categories-reset', { resetCount: 0 })));
  }

  reassignCategories(): Observable<any> {
    return this.http
      .post<any>('/api/inpost/reassign-categories', {})
      .pipe(catchError(ErrorHandler.handleError('inpost-reassign-categories', null)));
  }

}
